/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const userResponseOutputIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const userResponseOutputDisplayNameMax = 200;

export const userResponseOutputVersionExclusiveMin = 0;
export const userResponseOutputVersionMax = 9007199254740991;

export const UserResponseOutput = zod.object({
  id: zod.uuid().regex(userResponseOutputIdRegExp),
  displayName: zod.string().min(1).max(userResponseOutputDisplayNameMax),
  corporateState: zod.enum(['active', 'deactivated']),
  role: zod.union([zod.enum(['Agent', 'Admin']), zod.null()]),
  version: zod.int().gt(userResponseOutputVersionExclusiveMin).max(userResponseOutputVersionMax),
});

export type UserResponseOutput = zod.input<typeof UserResponseOutput>;
export type UserResponseOutputOutput = zod.output<typeof UserResponseOutput>;
